import { render } from "./AssemblyBar.vue?vue&type=template&id=1b3cb391&scoped=true"
import script from "./AssemblyBar.vue?vue&type=script&lang=js"
export * from "./AssemblyBar.vue?vue&type=script&lang=js"

import "./AssemblyBar.vue?vue&type=style&index=0&id=1b3cb391&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3cb391"]])

export default __exports__